/* eslint-disable import/prefer-default-export */
import { variants, th } from 'style/theme';
import styled, { css } from 'styled-components';
import { FaChevronLeft, FaTimes } from 'react-icons/fa';
import { sizes } from 'style';

const primaryVariant = css`
  background-color: ${th('colors.primaryButton.default')};
  color: ${th('colors.primaryButton.text')};

  :hover {
    background-color: ${th('colors.primaryButton.hover')};
  }

  :active {
    background-color: ${th('colors.primaryButton.active')};
  }
`;

const secondaryVariant = css`
  background-color: ${th('colors.secondaryButton.default')};
  color: ${th('colors.secondaryButton.text')};

  :hover {
    background-color: ${th('colors.secondaryButton.hover')};
  }

  :active {
    background-color: ${th('colors.secondaryButton.active')};
  }
`;

const darkVariant = css`
  background-color: ${th('colors.darkButton.default')};
  color: ${th('colors.darkButton.text')};

  :hover {
    background-color: ${th('colors.darkButton.hover')};
  }

  :active {
    background-color: ${th('colors.darkButton.active')};
  }
`;

const dangerVariant = css`
  background-color: ${th('colors.dangerButton.default')};
  color: ${th('colors.dangerButton.text')};

  :hover {
    background-color: ${th('colors.dangerButton.hover')};
  }

  :active {
    background-color: ${th('colors.dangerButton.active')};
  }
`;

const successVariant = css`
  background-color: ${th('colors.successButton.default')};
  color: ${th('colors.successButton.text')};

  :hover {
    background-color: ${th('colors.successButton.hover')};
  }

  :active {
    background-color: ${th('colors.successButton.active')};
  }
`;

const outlineVariant = css`
  background-color: transparent;
  color: ${th('colors.white')};
  border: 1px solid ${th('colors.white')};

  :hover {
    background-color: ${th('colors.white')};
    color: ${th('colors.black')};
  }

  :active {
    background-color: #f2f2f2;
    color: ${th('colors.black')};
  }
`;

const disabledVariant = css`
  background-color: ${th('colors.disabledButton.default')};
  color: ${th('colors.disabledButton.text')};

  :hover {
    background-color: ${th('colors.disabledButton.hover')};
  }

  :active {
    background-color: ${th('colors.disabledButton.active')};
  }
`;

const deleteVariant = css`
  color: ${th('colors.red')};
  box-shadow: none;
  font-size: 14px;
  text-align: center;
  padding: 4px 8px;
  background-color: transparent;

  :hover {
    background-color: ${th('colors.transparentWhite.1')};
  }
`;

const homeCtaVariant = css`
  background-color: ${th('colors.primaryButton.default')};
  color: ${th('colors.primaryButton.text')};

  :hover {
    background-color: ${th('colors.primaryButton.hover')};
  }

  :active {
    background-color: ${th('colors.primaryButton.active')};
  }

  @media ${sizes.mobileMedium} {
    width: 100%;
  }

  @media ${sizes.tabletPortrait} {
    width: inherit;
  }
`;

const flatVariant = css`
  border: 1px solid ${th('colors.flatButton.outline')};
  color: ${th('colors.flatButton.text')};
  box-shadow: none;
  padding: 20px 30px;
  background-color: transparent;
  text-align: left;
  font-weight: normal;
  line-height: 26px;

  :hover {
    background-color: ${th('colors.flatButton.hover')};
  }

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: ${th('colors.flatButton.hover')};
    `}
`;

export const StyledButton = styled.button`
  border-radius: 5px;
  padding: 9px 28px;
  font-size: 16px;
  box-sizing: border-box;
  text-align: center;
  outline: none;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: ${th('shadows.small')};
  text-decoration: none;
  display: inline-block;
  line-height: 1.33;
  transition: background 0.2s;

  ${({ variant }) =>
    variant === 'disabled' &&
    css`
      cursor: default;
    `}

  ${variants('variant', {
    primary: primaryVariant,
    secondary: secondaryVariant,
    dark: darkVariant,
    danger: dangerVariant,
    success: successVariant,
    outline: outlineVariant,
    disabled: disabledVariant,
    delete: deleteVariant,
    home: homeCtaVariant,
    flat: flatVariant
  })};

  > a {
    text-decoration: none;
  }

  :disabled {
    cursor: default;
  }
`;

export const StyledBackButton = styled(StyledButton)`
  ${variants('variant', {
    light: css`
      color: #ffffff80;

      :hover {
        background-color: ${th('colors.transparentWhite.1')};
        color: ${th('colors.white')};
      }

      :active {
        background-color: ${th('colors.transparentWhite.2')};
      }

      > i {
        color: #ffffff80;
      }
    `,
    dark: css`
      color: ${th('colors.silverChaliceGray')};

      :hover {
        background-color: ${th('colors.transparentBlack.1')};
        color: ${th('colors.black')};
      }

      :active {
        background-color: ${th('colors.transparentBlack.2')};
      }

      > i {
        color: ${th('colors.silverChaliceGray')};
      }
    `,
    disabled: css`
      color: #ffffff80;

      :hover {
        background-color: transparent;
        color: #ffffff80;
      }
    `
  })}

  background-color: transparent;
  font-weight: normal;
  box-shadow: none;
`;

export const BackIcon = styled(FaChevronLeft)`
  margin-right: 6px;
  font-size: 13px;
  position: relative;
  top: 1px;
`;

export const StyledCloseButton = styled(StyledButton)`
  color: ${th('colors.white')};
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  padding: 0px;
  background-color: ${th('colors.red')};
  border-radius: 50%;

  :hover {
    background-color: #ab4439;
    color: ${th('colors.white')};
  }
`;

export const CloseIcon = styled(FaTimes)`
  font-size: 12px;
  position: relative;
  top: 1px;
`;
